import {
  Building2,
  MessageSquare,
  BarChart3,
  type LucideIcon
} from 'lucide-react';

export interface MenuItem {
  label: string;
  path: string;
  icon: LucideIcon;
}

export const menuItems: MenuItem[] = [
  {
    label: 'Accounts',
    path: '/accounts',
    icon: Building2
  },
  {
    label: 'Feedbacks',
    path: '/feedbacks',
    icon: MessageSquare
  },
  {
    label: 'Analytics',
    path: '/analytics',
    icon: BarChart3
  }
];
